import { AutocompletePredictionTypes } from '../types';
import { autocompletePredictionToSearchResults } from 'utils/google-maps/googleSearchPredictions';
import { CountryCode, CountryCodeList } from 'types/countries';
import SearchPrediction from 'data/search-predictions';
import { assertGoogleApiKey, fetchPlacePredictions, getAutoCompleteService } from './placePredictions';

// Home appraisal search: 1 request, one country.
export async function getHomeAppraisalPredictions(
  input: string,
  country: CountryCode = CountryCodeList.CANADA // Country of origin
): Promise<SearchPrediction[]> {
  assertGoogleApiKey();

  // Unlike listings search, home appraisal shows no Google results instead of
  // throwing when the places library fails to load.
  const autocompleteService = await getAutoCompleteService();
  if (!autocompleteService) {
    return [];
  }

  // Only street addresses (street number present). ADDRESS would also return
  // units and buildings, which show up labelled as a city.
  const predictions = await fetchPlacePredictions(autocompleteService, input, AutocompletePredictionTypes.STREET_ADDRESS, [country]);
  const uniquePredictions = Array.from(new Map(predictions.map(prediction => [prediction.place_id, prediction])).values());

  // Show the country of origin first
  const countryName = country === CountryCodeList.CANADA ? 'Canada' : 'USA';
  const sortedPredictions = uniquePredictions.sort((a, b) => {
    const isACountryOfOrigin = a.terms.some(term => term.value === countryName);
    const isBCountryOfOrigin = b.terms.some(term => term.value === countryName);
    return isACountryOfOrigin === isBCountryOfOrigin ? 0 : isACountryOfOrigin ? -1 : 1;
  });

  // Parse results to make it works with advanced search dropdown component
  return autocompletePredictionToSearchResults(sortedPredictions) as SearchPrediction[];
}
